const interactiveComponent = (container: HTMLElement) => {
  const tabContent = container.querySelectorAll<HTMLElement>(".container__inner");
  const tabItem = container.querySelectorAll<HTMLElement>(".container__item");

  const resetTabs = () => {
    tabContent.forEach((item) => {
      item.classList.add("container__inner_hidden");
      const videos = item.querySelectorAll("video");
      videos.forEach((video) => {
        if (video) {
          video.pause();
          // eslint-disable-next-line no-param-reassign
          video.currentTime = 0; // Reset video to the start
        }
      });
    });
    tabItem.forEach((item) => item.classList.remove("container__item_active"));
  };

  const showTabFromHash = () => {
    const { hash } = window.location;
    if (!hash) return;
    const activeItem = Array.from(tabItem).find((item) => item.querySelector(`a[href="${hash}"]`));
    if (!activeItem) return;

    resetTabs();

    const activeContent = container.querySelector<HTMLElement>(hash);
    if (activeContent && activeItem) {
      activeContent.classList.remove("container__inner_hidden");
      activeItem.classList.add("container__item_active");

      const videos = activeContent.querySelectorAll("video");
      videos.forEach((video) => {
        if (video) {
          video.play(); // Play video when the tab is activated
        }
      });
    }
  };

  tabItem.forEach((item) => {
    item.addEventListener("click", (event) => {
      event.preventDefault();
      const hash = item.querySelector<HTMLElement>("a")?.getAttribute("href");
      if (hash) {
        // Použijeme replaceState, aby se URL změnila bez scrollování
        // eslint-disable-next-line no-restricted-globals
        history.replaceState(null, "", hash);
        showTabFromHash(); // Manually trigger the tab switch on click
      }
    });
  });

  window.addEventListener("hashchange", showTabFromHash);
  showTabFromHash(); // Initialize based on the current hash
};

export default interactiveComponent;
